/* CN Fees: statiegeld-motor. Uitleg en instellingen: snippets/cn-fees.liquid
   (config in window.CN_FEES_CONFIG; de herkenning van statiegeldregels,
   cnFeeRules en cnIsFeeLine, staat daar ook, want de winkelwagenpagina
   gebruikt die al tijdens het inlezen). */
(function () {
  'use strict';
  if (window.__cnFeesLoaded) return;
  window.__cnFeesLoaded = true;

  /* CN_FEES_CONFIG_OVERRIDE: test-haakje (E2E-scripts) — overschrijft de
     config vóór engine-init zonder de snippet te wijzigen. */
  var CFG = window.CN_FEES_CONFIG_OVERRIDE || window.CN_FEES_CONFIG || { rules: [] };
  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var XHR_HDRS = { 'X-Requested-With': 'XMLHttpRequest' };

  /* De herkenning (cnFeeVariantIds, cnFeeRules, cnIsFeeLine) staat inline in
     snippets/cn-fees.liquid: de winkelwagenpagina gebruikt die al tijdens het
     inlezen, vóór dit uitgestelde bestand draait. */
  var feeIds = window.cnFeeVariantIds || [];
  if (!feeIds.length) return;

  /* Interlock: engine slaapt zolang de MMF-app-embed actief is —
     anders zouden beide systemen fees beheren (dubbel statiegeld).
     Check bij ELKE sync (niet alleen bij init): het embed-script laadt
     async, dus "nu nog niet aanwezig" betekent niet "afwezig". Zolang de
     pagina nog laadt (en jonger is dan 6 s) wachten we; wat in die tijd
     gevraagd werd, doen we direct na het laden alsnog. */
  var pageStart = Date.now();
  function mmfOn() {
    try {
      if (document.querySelector('magical-mandatory-fees')) return true;
      return !!(window.customElements && customElements.get('magical-mandatory-fees'));
    } catch (e) { return false; }
  }
  function stillLoading() {
    return (Date.now() - pageStart) < 6000 && document.readyState !== 'complete';
  }
  var afterLoadQueued = false;
  var afterLoadCart = null;
  function syncAfterLoad(cart) {
    afterLoadCart = cart && cart.items ? cart : null;   /* laatste vraag telt; null = zelf ophalen */
    if (afterLoadQueued) return;
    afterLoadQueued = true;
    var go = function () {
      if (!afterLoadQueued) return;
      afterLoadQueued = false;
      syncFees(afterLoadCart);
    };
    window.addEventListener('load', go, { once: true });
    setTimeout(go, Math.max(0, 6000 - (Date.now() - pageStart)) + 50);
  }

  /* Laatst bekende winkelwagen: uit Liquid bij het laden, daarna uit elke
     sync, elk cart:updated-event en elk antwoord van /cart/change|update.
     Bepaalt alleen of de hartslag (zie onderaan) iets te doen heeft. */
  var known = (window.CN_CART && window.CN_CART.cart) || null;
  function noteCart(cart) { if (cart && Array.isArray(cart.items)) known = cart; }
  function needsWatch() {
    if (!known || !Array.isArray(known.items)) return true;
    var rules = window.cnFeeRules || [];
    return known.items.some(function (it) {
      var vid = Number(it.variant_id);
      var pid = Number(it.product_id);
      if (feeIds.indexOf(vid) !== -1) return true;
      return rules.some(function (r) {
        return r.matchProductIds.indexOf(pid) !== -1 || r.matchVariantIds.indexOf(vid) !== -1;
      });
    });
  }

  function expectedFees(cart) {
    var out = {};
    feeIds.forEach(function (id) { out[id] = 0; });
    CFG.rules.forEach(function (rule) {
      var feeId = Number(rule.feeVariantId);
      var per = Number(rule.qtyPerUnit) || 1;
      (cart.items || []).forEach(function (it) {
        if (feeIds.indexOf(Number(it.variant_id)) !== -1) return;   /* fee zelf telt niet */
        var hit = (rule.matchProductIds || []).indexOf(it.product_id) !== -1
          || (rule.matchVariantIds || []).indexOf(it.variant_id) !== -1;
        if (hit) out[feeId] += it.quantity * per;
      });
    });
    return out;
  }

  function actualFees(cart) {
    var out = {};
    feeIds.forEach(function (id) { out[id] = 0; });
    (cart.items || []).forEach(function (it) {
      var n = Number(it.variant_id);
      if (feeIds.indexOf(n) !== -1) {
        out[n] += it.quantity;
        /* Waakhond: statiegeld is een borg en mag NOOIT korting krijgen
           (order-brede kortingscodes zouden 'm kunnen raken). Detecteer
           en meld luid — herstel-actie is een admin-kwestie: codes op
           collecties/producten richten i.p.v. de hele order (zie README
           "Kortingscodes & btw"). */
        if ((it.final_price || 0) < (it.price || 0) && !window.__cnFeeDiscountWarned) {
          window.__cnFeeDiscountWarned = true;
          try {
            console.error('[CN Fees] LET OP: de fee-regel "' + (it.product_title || it.title) + '" krijgt korting ('
              + it.price + ' → ' + it.final_price + '). Statiegeld hoort nooit korting te krijgen. '
              + 'Richt kortingscodes op producten/collecties i.p.v. de hele order.');
          } catch (e) {}
        }
      }
    });
    return out;
  }

  /* Wat moet er veranderen? Nieuwe fee-regels via /cart/add.js (mét
     _cn_fee-marker als property); bestaande regels bijstellen of verwijderen
     via de updates-API (absolute aantallen, idempotent, geen line-keys). */
  function diffFees(cart) {
    var exp = expectedFees(cart);
    var act = actualFees(cart);
    var d = { toAdd: [], updates: {}, hasUpdates: false };
    feeIds.forEach(function (id) {
      if (exp[id] === act[id]) return;
      if (act[id] === 0 && exp[id] > 0) {
        d.toAdd.push({ id: id, quantity: exp[id], properties: { _cn_fee: '1' } });
      } else {
        d.updates[id] = exp[id];
        d.hasUpdates = true;
      }
    });
    return d;
  }

  function fetchCart() {
    return fetch(routes + 'cart.js', { cache: 'no-store', headers: XHR_HDRS })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { noteCart(c); return c && c.items ? c : null; });
  }

  var runAgain = false;
  /* Failure-backoff: bij herhaald falende syncs (bot-challenge, netwerk-
     storing, config-fout) niet op elk cart-event blijven hameren — dat
     verergert rate-limiting juist. Na 3 opeenvolgende mislukkingen 60s
     pauze; een geslaagde sync reset de teller. */
  var failStreak = 0;
  var backoffUntil = 0;
  /* Lopende sync (promise) — zodat parallelle aanroepen KOPPELEN i.p.v.
     meteen een lege 'false' terugkrijgen. Cruciaal voor de render-coupling:
     als een engine-trigger (fetch-wrap op /cart/change.js) al aan het
     syncen is wanneer een cart-flow vlak vóór z'n render cnFeesEnsure
     await, moet die await op de ÉCHTE mutatie wachten — anders rendert 'ie
     het product nu en het statiegeld pas 1s later. */
  var inFlight = null;
  /* Mutatie-teller: bumpt bij elke geslaagde fee-wijziging. Render-callers
     vergelijken 'm rond hun ensure-await en her-fetchen als 'ie opliep —
     óók als een PARALLELLE sync de mutatie deed (die geeft dan via de
     gekoppelde promise 'true', en anders vangt de teller het). */
  if (typeof window.cnFeesMutationSeq !== 'number') window.cnFeesMutationSeq = 0;

  async function doSyncFees(cartArg, opts) {
    opts = opts || {};
    try {
      var cart = cartArg && cartArg.items ? cartArg : null;
      var fresh = !cart;
      if (fresh) cart = await fetchCart();
      if (!cart) return false;
      noteCart(cart);

      var d = diffFees(cart);
      if (!d.toAdd.length && !d.hasUpdates) return false;
      /* Een meegegeven winkelwagen (event, antwoord van /cart/change) kan net
         achterlopen op een sync die intussen klaar is. Vóór het wijzigen dus
         altijd één keer vers kijken: nooit een tweede statiegeldregel. */
      if (!fresh) {
        cart = await fetchCart();
        if (!cart) return false;
        d = diffFees(cart);
        if (!d.toAdd.length && !d.hasUpdates) return false;
      }

      /* _cn_fees=1: onze eigen fetch-trigger negeert deze calls (geen sync-lus). */
      var failedStatus = 0;
      if (d.toAdd.length) {
        var addRes = await fetch(routes + 'cart/add.js?_cn_fees=1', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: d.toAdd }),
        });
        if (!addRes.ok) failedStatus = addRes.status;
      }
      if (d.hasUpdates) {
        var upRes = await fetch(routes + 'cart/update.js?_cn_fees=1', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ updates: d.updates }),
        });
        if (!upRes.ok && !failedStatus) failedStatus = upRes.status;
      }
      if (failedStatus) {
        /* 422/404 = fee-product bestaat niet of is niet gepubliceerd op
           het Online Store-kanaal. LUID melden — stil falen zou
           onvindbaar zijn. Eén keer per sessie. */
        if (!window.__cnFeesConfigWarned) {
          window.__cnFeesConfigWarned = true;
          try {
            console.error('[CN Fees] Fee-sync geweigerd (HTTP ' + failedStatus + '). '
              + 'Controleer: bestaat het Statiegeld-product, is het gepubliceerd op het '
              + 'Online Store-kanaal, en klopt feeVariantId in snippets/cn-fees.liquid?');
          } catch (e2) {}
        }
        failStreak += 1;
        if (failStreak >= 3) { backoffUntil = Date.now() + 60000; failStreak = 0; }
        return false;
      }
      failStreak = 0;

      /* Mutatie geslaagd → teller bumpen zodat render-callers weten dat ze
         moeten her-fetchen, ook als zij niet degene waren die 't uitvoerde
         (parallelle engine-trigger vs. awaitende cart-flow). */
      try { window.cnFeesMutationSeq = (window.cnFeesMutationSeq || 0) + 1; } catch (eSeq) {}

      /* Verse cart ophalen en UI's informeren; source-tag voorkomt dat we
         onszelf her-triggeren. opts.silent: de CALLER rendert zelf (fee-
         sync loopt dan mee onder hetzelfde bezig-signaal — product en
         statiegeld verschijnen in één render), dus geen eigen event. */
      if (!opts.silent) {
        try {
          var updated = await fetchCart();
          if (updated) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: updated, source: 'cn-fees' } }));
        } catch (e) { /* UI ververst bij volgende event */ }
      }
      return true;
    } catch (e) {
      return false;                             /* netwerkfout → volgende trigger herstelt */
    }
  }

  /* Wrapper met interlock, backoff en sync-coalescing. Houdt de lopende
     sync bij zodat parallelle aanroepen eraan koppelen (zie inFlight). */
  function syncFees(cartArg, opts) {
    opts = opts || {};
    if (cartArg && cartArg.items) noteCart(cartArg);
    if (mmfOn()) return Promise.resolve(false);   /* interlock: MMF beheert de fees nog */
    if (stillLoading()) { syncAfterLoad(cartArg); return Promise.resolve(false); }
    if (Date.now() < backoffUntil) return Promise.resolve(false);
    /* Al een sync bezig? Geef de lopende promise terug — de caller wacht zo
       op de échte mutatie i.p.v. een lege 'false'. runAgain zorgt dat er ná
       deze sync nog één volgt met een verse cart (idempotent als alles dan
       al klopt). */
    if (inFlight) { runAgain = true; return inFlight; }
    var p = doSyncFees(cartArg, opts);
    inFlight = p;
    var settle = function () {
      if (inFlight === p) inFlight = null;
      if (runAgain) { runAgain = false; setTimeout(function () { syncFees(); }, 150); }
    };
    p.then(settle, settle);
    return p;
  }

  /* Checkout-garantie-hook + render-hook: de checkout-safeguard await
     dit vlak vóór het navigeren, en de cart-flows awaiten het (met
     {silent:true}) vóór hun render zodat product + statiegeld samen
     verschijnen. In-sync cart = directe no-op zonder netwerk-calls. */
  window.cnFeesEnsure = function (cart, opts) { return syncFees(cart && cart.items ? cart : null, opts); };

  /* ── Triggers ── */
  var debounceTimer = null;
  function scheduleSync(cart, delay) {
    var c = cart && cart.items ? cart : null;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { syncFees(c); }, typeof delay === 'number' ? delay : 250);
  }

  /* 1. Thema-events (drawer/cart-page dispatchen cart:updated op elke flow).
     De lade roept bij het laden zelf cnFeesEnsure aan met de winkelwagen;
     een eigen opstartronde is daarom niet nodig. */
  document.addEventListener('cart:updated', function (e) {
    var d = (e && e.detail) || {};
    if (d.cart && d.cart.items) noteCart(d.cart);
    if (d.source === 'cn-fees') return;
    scheduleSync(d.cart);
  });

  /* 2. Vangnet voor winkelwagenwijzigingen buiten die events om (apps,
     andere thema-onderdelen): een lichte fetch-wrap die alleen kijkt.
     - /cart/update zonder "updates" (alleen kenmerken, notitie of
       kortingscode, bv. Analyzify): de regels veranderen niet, niets doen.
     - Het antwoord van /cart/change, /cart/update en /cart/clear is de hele
       winkelwagen: die gebruiken we, zonder zelf opnieuw op te halen.
     - Toevoegen: na 1,2 s zelf kijken, tenzij er intussen een cart:updated
       met winkelwagen binnenkwam (de lade stuurt die na elke toevoeging). */
  function changesLines(url, init) {
    if (!/\/cart\/update/.test(url)) return true;
    if (/[?&]updates/.test(url)) return true;
    var b = init && init.body;
    if (b == null) return false;
    if (typeof b === 'string') return b.indexOf('updates') !== -1;
    if (typeof b.forEach === 'function' && typeof b.get === 'function') {   /* FormData, URLSearchParams */
      var hit = false;
      b.forEach(function (v, k) { if (String(k).indexOf('updates') === 0) hit = true; });
      return hit;
    }
    return true;                                  /* onbekend soort body: voor de zekerheid wel */
  }
  try {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var p = origFetch.apply(this, arguments);
      try {
        var isRequest = !!(input && typeof input === 'object' && typeof input.url === 'string');
        var url = typeof input === 'string' ? input : (isRequest ? input.url : String(input || ''));
        if (/\/cart\/(add|change|update|clear)/.test(url) && !/_cn_fees=1/.test(url)
            && (isRequest || changesLines(url, init))) {
          var isAdd = /\/cart\/add/.test(url);
          p.then(function (res) {
            if (isAdd || !res || !res.ok) { scheduleSync(null, 1200); return; }
            res.clone().json().then(function (cart) {
              if (cart && Array.isArray(cart.items)) scheduleSync(cart);
              else scheduleSync(null, 1200);
            }, function () { scheduleSync(null, 1200); });
          }, function () {});
        }
      } catch (e) { /* nooit een request breken */ }
      return p;
    };
  } catch (e) { /* fetch niet wrapbaar → events dekken 't */ }

  /* 3. Terug uit de kassa (bfcache): de lade haalt de winkelwagen op en
     stuurt cart:updated; komt dat niet binnen 1,2 s, dan kijken we zelf. */
  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted) scheduleSync(null, 1200);
  });

  /* 4. Hartslag (vangnet voor elk gemist moment). Praktijkbug: cart volledig
     leeggehaald maar de fee-regel bleef hangen. Elke 12 s bij een zichtbaar
     tabblad, en meteen als het tabblad weer zichtbaar wordt, maar alleen als
     er statiegeld of een statiegeldplichtig product in de winkelwagen zit.
     Zonder zulke regels valt er niets te herstellen en blijft het stil. */
  setInterval(function () {
    if (document.visibilityState === 'visible' && needsWatch()) scheduleSync(null);
  }, 12000);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && needsWatch()) scheduleSync(null);
  });
})();
